import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-besc-card shadow-sm" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-30 letter-spacing" }
const _hoisted_3 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_4 = { class: "row g-3 mb-4" }
const _hoisted_5 = { class: "col-md-4" }
const _hoisted_6 = { class: "d-flex justify-content-between align-items-center mb-2" }
const _hoisted_7 = { class: "col-md-4" }
const _hoisted_8 = { class: "d-flex justify-content-between align-items-center mb-2" }
const _hoisted_9 = { class: "col-md-4" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "col-md-4" }
const _hoisted_12 = { class: "d-flex justify-content-between align-items-center mb-2" }
const _hoisted_13 = { class: "col-md-4" }
const _hoisted_14 = {
  key: 0,
  class: "text-danger d-block mt-1"
}
const _hoisted_15 = { class: "col-md-4" }
const _hoisted_16 = {
  key: 0,
  class: "text-danger d-block mt-1"
}
const _hoisted_17 = { class: "col-md-4" }
const _hoisted_18 = {
  key: 0,
  class: "text-danger d-block mt-1"
}
const _hoisted_19 = { class: "col-md-4" }
const _hoisted_20 = {
  key: 0,
  class: "col-md-12"
}
const _hoisted_21 = { class: "alert alert-danger text-center py-3 px-4 mt-3" }
const _hoisted_22 = { class: "text-start" }
const _hoisted_23 = { class: "mb-0" }
const _hoisted_24 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_25 = {
  key: 1,
  class: "mb-2"
}
const _hoisted_26 = {
  key: 2,
  class: "mb-2"
}
const _hoisted_27 = {
  key: 3,
  class: "mb-2"
}
const _hoisted_28 = { class: "row g-3 mb-4" }
const _hoisted_29 = { class: "col-md-4" }
const _hoisted_30 = { class: "d-flex justify-content-between align-items-center mb-2" }
const _hoisted_31 = { class: "col-md-4" }
const _hoisted_32 = { class: "col-md-4" }
const _hoisted_33 = { class: "d-flex gap-3" }
const _hoisted_34 = { class: "form-check" }
const _hoisted_35 = ["checked", "onChange"]
const _hoisted_36 = { class: "form-check" }
const _hoisted_37 = ["checked", "onChange"]
const _hoisted_38 = {
  key: 0,
  class: "col-md-4"
}
const _hoisted_39 = {
  key: 1,
  class: "col-md-4"
}
const _hoisted_40 = { class: "d-flex justify-content-between align-items-center mb-2" }
const _hoisted_41 = { class: "col-md-4" }
const _hoisted_42 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_43 = { class: "col-md-4" }
const _hoisted_44 = { class: "col-md-4" }
const _hoisted_45 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_46 = { class: "col-md-4" }
const _hoisted_47 = { class: "col-md-4" }
const _hoisted_48 = {
  key: 2,
  class: "col-md-12"
}
const _hoisted_49 = { class: "alert alert-danger text-center py-3 px-4 mt-3" }
const _hoisted_50 = { class: "text-start" }
const _hoisted_51 = { class: "mb-0" }
const _hoisted_52 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_53 = {
  key: 1,
  class: "mb-2"
}
const _hoisted_54 = {
  key: 2,
  class: "mb-2"
}
const _hoisted_55 = {
  key: 3,
  class: "mb-2"
}
const _hoisted_56 = {
  key: 4,
  class: "mb-2"
}
const _hoisted_57 = {
  key: 5,
  class: "mb-2"
}
const _hoisted_58 = { class: "d-flex justify-content-between align-items-center mt-5 pt-4 border-top" }
const _hoisted_59 = { class: "d-flex gap-3" }
const _hoisted_60 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StepProgressTracker = _resolveComponent("StepProgressTracker")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!
  const _component_ActeurModal = _resolveComponent("ActeurModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_StepProgressTracker, {
      "current-step": 'step1',
      "besc-id": _ctx.bescId
    }, null, 8, ["besc-id"]),
    _cache[47] || (_cache[47] = _createElementVNode("div", {
      class: "card-header d-flex justify-content-between align-items-center py-4 px-4",
      style: {"background-color":"#0a59a4"}
    }, [
      _createElementVNode("div", null, [
        _createElementVNode("h3", { class: "text-white fw-bold mb-1" }, "Étape 1/4 – Informations de base du BESC"),
        _createElementVNode("small", { class: "text-white opacity-75" }, "Remplissez les informations générales du bordereau")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.loadingBesc)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[6] || (_cache[6] = [
            _createElementVNode("div", {
              class: "spinner-border text-primary",
              role: "status"
            }, [
              _createElementVNode("span", { class: "visually-hidden" }, "Chargement...")
            ], -1),
            _createElementVNode("p", { class: "mt-3 text-muted" }, "Chargement des données...", -1)
          ]))]))
        : _createCommentVNode("", true),
      _createVNode(_component_Form, {
        "initial-values": _ctx.form,
        "validation-schema": _ctx.schema,
        onSubmit: _ctx.saveStep1
      }, {
        default: _withCtx(() => [
          _cache[45] || (_cache[45] = _createElementVNode("div", { class: "section-title mb-4" }, [
            _createElementVNode("h5", { class: "text-primary fw-bold border-bottom pb-2" }, "Parties prenantes")
          ], -1)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _cache[8] || (_cache[8] = _createElementVNode("label", { class: "text-black fw-semibold mb-0" }, [
                  _createTextVNode(" Importateur / Destinataire "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createElementVNode("a", {
                  href: "#",
                  class: "btn btn-primary btn-sm",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.openActeurModal('importateur', 'Importateur')), ["prevent"])),
                  title: "Ajouter un nouvel importeur"
                }, [...(_cache[7] || (_cache[7] = [
                  _createElementVNode("i", { class: "flaticon-plus" }, null, -1)
                ]))])
              ]),
              _createVNode(_component_Field, { name: "importateur" }, {
                default: _withCtx(({ field, setValue }) => [
                  _createVNode(_component_Multiselect, {
                    "model-value": field.value,
                    "onUpdate:modelValue": async (val) => {
                  setValue(val);
                  const acteur = _ctx.acteursParType.importateur.find(a => a.value === val);
                  if (acteur?.refActeur) {
                    const result = await _ctx.checkBlacklist('PERSON', acteur.refActeur);
                    _ctx.blacklistAlerts.importateur = result.isBlacklisted ? result.details : null;
                  } else {
                    _ctx.blacklistAlerts.importateur = null;
                  }
                },
                    options: _ctx.acteursParType.importateur,
                    searchable: true,
                    loading: _ctx.loadingActeurs,
                    placeholder: "Rechercher un importateur...",
                    label: "label",
                    "track-by": "value"
                  }, null, 8, ["model-value", "onUpdate:modelValue", "options", "loading"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _cache[10] || (_cache[10] = _createElementVNode("label", { class: "text-black fw-semibold mb-0" }, [
                  _createTextVNode(" Partie à notifier "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createElementVNode("a", {
                  href: "#",
                  class: "btn btn-primary btn-sm",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.openActeurModal('partieANotifier', 'Partie à notifier')), ["prevent"])),
                  title: "Ajouter une partie à notifier"
                }, [...(_cache[9] || (_cache[9] = [
                  _createElementVNode("i", { class: "flaticon-plus" }, null, -1)
                ]))])
              ]),
              _createVNode(_component_Field, { name: "partieANotifier" }, {
                default: _withCtx(({ field, setValue }) => [
                  _createVNode(_component_Multiselect, {
                    "model-value": field.value,
                    "onUpdate:modelValue": async (val) => {
                  setValue(val);
                  const acteur = _ctx.acteursParType.partie_a_notifier.find(a => a.value === val);
                  if (acteur?.refActeur) {
                    const result = await _ctx.checkBlacklist('PERSON', acteur.refActeur);
                    _ctx.blacklistAlerts.partieANotifier = result.isBlacklisted ? result.details : null;
                  } else {
                    _ctx.blacklistAlerts.partieANotifier = null;
                  }
                },
                    options: _ctx.acteursParType.partie_a_notifier,
                    searchable: true,
                    loading: _ctx.loadingActeurs,
                    placeholder: "Rechercher une partie...",
                    label: "label",
                    "track-by": "value"
                  }, null, 8, ["model-value", "onUpdate:modelValue", "options", "loading"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[11] || (_cache[11] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-2" }, [
                _createTextVNode(" Transitaire "),
                _createElementVNode("span", { class: "text-danger" }, "*")
              ], -1)),
              _createVNode(_component_Field, { name: "transitaire" }, {
                default: _withCtx(({ field }) => [
                  (_ctx.isTransitaire)
                    ? (_openBlock(), _createElementBlock("input", {
                        key: 0,
                        type: "text",
                        class: "form-control shadow-sm bg-light text-muted",
                        disabled: true,
                        value: _ctx.transitaireNom
                      }, null, 8, _hoisted_10))
                    : (_openBlock(), _createBlock(_component_Multiselect, {
                        key: 1,
                        "model-value": field.value,
                        "onUpdate:modelValue": (val) => field.onChange(val),
                        options: _ctx.usersTransitaires,
                        searchable: true,
                        loading: _ctx.loadingTransitaires,
                        placeholder: "Rechercher un transitaire...",
                        label: "label",
                        "track-by": "value"
                      }, null, 8, ["model-value", "onUpdate:modelValue", "options", "loading"]))
                ]),
                _: 1
              }),
              _createVNode(_component_ErrorMessage, {
                name: "transitaire",
                class: "text-danger d-block mt-1"
              })
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _cache[13] || (_cache[13] = _createElementVNode("label", { class: "text-black fw-semibold mb-0" }, [
                  _createTextVNode(" Expéditeur "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createElementVNode("a", {
                  href: "#",
                  class: "btn btn-primary btn-sm",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.openActeurModal('expediteur', 'Expediteur')), ["prevent"])),
                  title: "Ajouter un nouvel expediteur"
                }, [...(_cache[12] || (_cache[12] = [
                  _createElementVNode("i", { class: "flaticon-plus" }, null, -1)
                ]))])
              ]),
              _createVNode(_component_Field, { name: "expediteur" }, {
                default: _withCtx(({ field, setValue }) => [
                  _createVNode(_component_Multiselect, {
                    "model-value": field.value,
                    "onUpdate:modelValue": async (val) => {
                  setValue(val);
                  const acteur = _ctx.acteursParType.expediteur.find(a => a.value === val);
                  if (acteur?.refActeur) {
                    const result = await _ctx.checkBlacklist('PERSON', acteur.refActeur);
                    _ctx.blacklistAlerts.expediteur = result.isBlacklisted ? result.details : null;
                  } else {
                    _ctx.blacklistAlerts.expediteur = null;
                  }
                },
                    options: _ctx.acteursParType.expediteur,
                    searchable: true,
                    loading: _ctx.loadingActeurs,
                    placeholder: "Rechercher un expediteur...",
                    label: "label",
                    "track-by": "value"
                  }, null, 8, ["model-value", "onUpdate:modelValue", "options", "loading"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_13, [
              _cache[14] || (_cache[14] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center mb-2" }, [
                _createElementVNode("label", { class: "text-black fw-semibold mb-0" }, " Incoterm "),
                _createElementVNode("span")
              ], -1)),
              _createVNode(_component_Field, { name: "incoterm" }, {
                default: _withCtx(({ field, setValue, errorMessage }) => [
                  _createVNode(_component_Multiselect, {
                    "model-value": field.value,
                    "onUpdate:modelValue": setValue,
                    options: _ctx.incoterms,
                    placeholder: "Sélectionner",
                    label: "label",
                    "track-by": "value"
                  }, null, 8, ["model-value", "onUpdate:modelValue", "options"]),
                  errorMessage
                    ? (_openBlock(), _createElementBlock("small", _hoisted_14, _toDisplayString(errorMessage), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_15, [
              _cache[15] || (_cache[15] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-2" }, [
                _createTextVNode(" Pays d'origine "),
                _createElementVNode("span", { class: "text-danger" }, "*")
              ], -1)),
              _createVNode(_component_Field, { name: "paysOrigine" }, {
                default: _withCtx(({ field, setValue, errorMessage }) => [
                  _createVNode(_component_Multiselect, {
                    "model-value": field.value,
                    "onUpdate:modelValue": async (val) => { 
                  _ctx.form.paysOrigine = val; 
                  setValue(val);           
                  _ctx.onPaysOrigineChange();
                  const paysObj = _ctx.paysAvecCodes.find(p => p.value === val);
                  if (paysObj?.iso2_code) {
                    const result = await _ctx.checkBlacklist('COUNTRY', paysObj.iso2_code);
                    _ctx.blacklistAlerts.paysOrigine = result.isBlacklisted ? result.details : null;
                  } else {
                    _ctx.blacklistAlerts.paysOrigine = null;
                  }
                },
                    options: _ctx.pays,
                    searchable: true,
                    "filter-results": true,
                    "value-prop": "value",
                    label: "label",
                    "resolve-on-load": false,
                    placeholder: "Rechercher..."
                  }, null, 8, ["model-value", "onUpdate:modelValue", "options"]),
                  errorMessage
                    ? (_openBlock(), _createElementBlock("small", _hoisted_16, _toDisplayString(errorMessage), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_17, [
              _cache[16] || (_cache[16] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-2" }, [
                _createTextVNode(" Paiement du fret "),
                _createElementVNode("span", { class: "text-danger" }, "*")
              ], -1)),
              _createVNode(_component_Field, { name: "typeFret" }, {
                default: _withCtx(({ field, setValue, errorMessage }) => [
                  _createVNode(_component_Multiselect, {
                    "model-value": field.value,
                    "onUpdate:modelValue": setValue,
                    options: _ctx.paiementFret,
                    loading: _ctx.loading,
                    placeholder: "Sélectionner",
                    label: "label",
                    "track-by": "value"
                  }, null, 8, ["model-value", "onUpdate:modelValue", "options", "loading"]),
                  errorMessage
                    ? (_openBlock(), _createElementBlock("small", _hoisted_18, _toDisplayString(errorMessage), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_19, [
              _cache[17] || (_cache[17] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-2" }, [
                _createTextVNode(" Numéro de BL / Connaissement "),
                _createElementVNode("span", { class: "text-danger" }, "*")
              ], -1)),
              _createVNode(_component_Field, {
                name: "numeroConnaissement",
                type: "text",
                class: "form-control shadow-sm",
                placeholder: "ex: MSCU123456789"
              }),
              _createVNode(_component_ErrorMessage, {
                name: "numeroConnaissement",
                class: "text-danger d-block mt-1"
              })
            ]),
            (_ctx.blacklistAlerts.importateur || _ctx.blacklistAlerts.partieANotifier || _ctx.blacklistAlerts.transitaire || _ctx.blacklistAlerts.expediteur)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _cache[22] || (_cache[22] = _createElementVNode("h6", { class: "fw-bold mb-3" }, [
                      _createElementVNode("i", { class: "ph-warning-circle fs-4" }),
                      _createTextVNode("ALERTE BLACKLIST - PARTIES PRENANTES ")
                    ], -1)),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("ul", _hoisted_23, [
                        (_ctx.blacklistAlerts.importateur)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_24, [
                              _cache[18] || (_cache[18] = _createElementVNode("strong", null, "Importateur:", -1)),
                              _createTextVNode(" Liste " + _toDisplayString(_ctx.blacklistAlerts.importateur.list_code) + " - " + _toDisplayString(_ctx.blacklistAlerts.importateur.reason), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.blacklistAlerts.partieANotifier)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_25, [
                              _cache[19] || (_cache[19] = _createElementVNode("strong", null, "Partie à notifier:", -1)),
                              _createTextVNode(" Liste " + _toDisplayString(_ctx.blacklistAlerts.partieANotifier.list_code) + " - " + _toDisplayString(_ctx.blacklistAlerts.partieANotifier.reason), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.blacklistAlerts.transitaire)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_26, [
                              _cache[20] || (_cache[20] = _createElementVNode("strong", null, "Transitaire:", -1)),
                              _createTextVNode(" Liste " + _toDisplayString(_ctx.blacklistAlerts.transitaire.list_code) + " - " + _toDisplayString(_ctx.blacklistAlerts.transitaire.reason), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.blacklistAlerts.expediteur)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_27, [
                              _cache[21] || (_cache[21] = _createElementVNode("strong", null, "Expéditeur:", -1)),
                              _createTextVNode(" Liste " + _toDisplayString(_ctx.blacklistAlerts.expediteur.list_code) + " - " + _toDisplayString(_ctx.blacklistAlerts.expediteur.reason), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _cache[46] || (_cache[46] = _createElementVNode("div", { class: "section-title mb-4 mt-5" }, [
            _createElementVNode("h5", { class: "text-primary fw-bold border-bottom pb-2" }, "Informations transport & itinéraire")
          ], -1)),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _cache[24] || (_cache[24] = _createElementVNode("label", { class: "text-black fw-semibold mb-0" }, [
                  _createTextVNode(" Transporteur "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createElementVNode("a", {
                  href: "#",
                  class: "btn btn-primary btn-sm",
                  onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.openActeurModal('transporteur', 'Transporteur')), ["prevent"])),
                  title: "Ajouter un nouvel transporteur"
                }, [...(_cache[23] || (_cache[23] = [
                  _createElementVNode("i", { class: "flaticon-plus" }, null, -1)
                ]))])
              ]),
              _createVNode(_component_Field, { name: "transporteur" }, {
                default: _withCtx(({ field, setValue }) => [
                  _createVNode(_component_Multiselect, {
                    "model-value": field.value,
                    "onUpdate:modelValue": async (val) => {
                  setValue(val);
                  const acteur = _ctx.acteursParType.transporteur.find(a => a.value === val);
                  if (acteur?.refActeur) {
                    const result = await _ctx.checkBlacklist('PERSON', acteur.refActeur);
                    _ctx.blacklistAlerts.transporteur = result.isBlacklisted ? result.details : null;
                  } else {
                    _ctx.blacklistAlerts.transporteur = null;
                  }
                },
                    options: _ctx.acteursParType.transporteur,
                    searchable: true,
                    loading: _ctx.loadingActeurs,
                    placeholder: "Rechercher un transporteur...",
                    label: "label",
                    "track-by": "value"
                  }, null, 8, ["model-value", "onUpdate:modelValue", "options", "loading"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_31, [
              _cache[25] || (_cache[25] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-2" }, "Navire", -1)),
              (_openBlock(), _createBlock(_component_Field, {
                name: "vessel",
                key: _ctx.vesselKey
              }, {
                default: _withCtx(({ field, setValue }) => [
                  _createVNode(_component_Multiselect, {
                    "model-value": field.value,
                    "onUpdate:modelValue": async (val) => {
                  setValue(val?.value || val);
                  const navire = _ctx.navires.find(n => n.value === (val?.value || val));
                  if (navire?.imo) {
                    const result = await _ctx.checkBlacklist('SHIP', navire.imo);
                    _ctx.blacklistAlerts.vessel = result.isBlacklisted ? result.details : null;
                  } else {
                    _ctx.blacklistAlerts.vessel = null;
                  }
                },
                    options: _ctx.navires,
                    searchable: true,
                    loading: _ctx.loadingNavires,
                    placeholder: "Rechercher (IMO ou MMSI)...",
                    label: "label",
                    "track-by": "value",
                    onSearchChange: (query) => _ctx.searchNavire(query, field.value),
                    "filter-results": false,
                    "min-chars": 2
                  }, null, 8, ["model-value", "onUpdate:modelValue", "options", "loading", "onSearchChange"])
                ]),
                _: 1
              }))
            ]),
            _createElementVNode("div", _hoisted_32, [
              _cache[28] || (_cache[28] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-2" }, "Transbordement", -1)),
              _createVNode(_component_Field, { name: "transbordement" }, {
                default: _withCtx(({ field, setValue }) => [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("input", {
                        class: "form-check-input",
                        type: "radio",
                        value: 'oui',
                        checked: field.value === 'oui',
                        onChange: () => { setValue('oui'); _ctx.showTransbordementFields = true },
                        id: "transbordementOui"
                      }, null, 40, _hoisted_35),
                      _cache[26] || (_cache[26] = _createElementVNode("label", {
                        class: "form-check-label",
                        for: "transbordementOui"
                      }, " Oui ", -1))
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("input", {
                        class: "form-check-input",
                        type: "radio",
                        value: 'non',
                        checked: field.value === 'non',
                        onChange: () => { setValue('non'); _ctx.showTransbordementFields = false },
                        id: "transbordementNon"
                      }, null, 40, _hoisted_37),
                      _cache[27] || (_cache[27] = _createElementVNode("label", {
                        class: "form-check-label",
                        for: "transbordementNon"
                      }, " Non ", -1))
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            (_ctx.showTransbordementFields)
              ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                  _cache[29] || (_cache[29] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-2" }, "Navire après transbordement", -1)),
                  _createVNode(_component_Field, { name: "navireApresTransbordement" }, {
                    default: _withCtx(({ field, setValue }) => [
                      _createVNode(_component_Multiselect, {
                        "model-value": field.value,
                        "onUpdate:modelValue": (val) => setValue(val?.value || val),
                        options: _ctx.navires,
                        searchable: true,
                        loading: _ctx.loadingNavires,
                        placeholder: "Rechercher (IMO ou MMSI)...",
                        label: "label",
                        "track-by": "value",
                        onSearchChange: _ctx.searchNavire,
                        "filter-results": false,
                        "min-chars": 2
                      }, null, 8, ["model-value", "onUpdate:modelValue", "options", "loading", "onSearchChange"])
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (_ctx.showTransbordementFields)
              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    _cache[31] || (_cache[31] = _createElementVNode("label", { class: "text-black fw-semibold mb-0" }, [
                      _createTextVNode(" Transporteur après transbordement "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createElementVNode("a", {
                      href: "#",
                      class: "btn btn-primary btn-sm",
                      onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.openActeurModal('transporteurApresTransbordement', 'Après transbordement')), ["prevent"])),
                      title: "Ajouter un nouvel transporteur après transbordement"
                    }, [...(_cache[30] || (_cache[30] = [
                      _createElementVNode("i", { class: "flaticon-plus" }, null, -1)
                    ]))])
                  ]),
                  _createVNode(_component_Field, { name: "transporteurApresTransbordement" }, {
                    default: _withCtx(({ field, setValue }) => [
                      _createVNode(_component_Multiselect, {
                        "model-value": field.value,
                        "onUpdate:modelValue": setValue,
                        options: _ctx.acteursParType.transporteurApresTransbordement,
                        searchable: true,
                        loading: _ctx.loadingActeurs,
                        placeholder: "Rechercher un transporteurApresTransbordement...",
                        label: "label",
                        "track-by": "value"
                      }, null, 8, ["model-value", "onUpdate:modelValue", "options", "loading"])
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_41, [
              _cache[32] || (_cache[32] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-2" }, [
                _createTextVNode(" Port de chargement "),
                _createElementVNode("span", { class: "text-danger" }, "*")
              ], -1)),
              _createVNode(_component_Field, { name: "portChargement" }, {
                default: _withCtx(({ field, setValue }) => [
                  _createVNode(_component_Multiselect, {
                    "model-value": field.value,
                    "onUpdate:modelValue": async (val) => {
                  setValue(val?.value || val);
                  const port = _ctx.portsChargement.find(p => p.value === (val?.value || val));
                  if (port?.locode) {
                    const result = await _ctx.checkBlacklist('PORT', port.locode);
                    _ctx.blacklistAlerts.portChargement = result.isBlacklisted ? result.details : null;
                  } else {
                    _ctx.blacklistAlerts.portChargement = null;
                  }
                },
                    options: _ctx.portsChargementFiltres,
                    searchable: true,
                    loading: _ctx.loadingPorts,
                    placeholder: "Tapez pour rechercher un port...",
                    label: "label",
                    "track-by": "value",
                    onSearchChange: _ctx.searchPortChargement,
                    "filter-results": false,
                    "min-chars": 2,
                    "no-options-text": "Commencez à taper pour rechercher le port du pays d'origine",
                    "no-results-text": "Aucun port trouvé"
                  }, null, 8, ["model-value", "onUpdate:modelValue", "options", "loading", "onSearchChange"])
                ]),
                _: 1
              }),
              (!_ctx.form.paysOrigine)
                ? (_openBlock(), _createElementBlock("small", _hoisted_42, " Sélectionnez d'abord un pays d'origine "))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_43, [
              _cache[33] || (_cache[33] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-2" }, [
                _createTextVNode(" Destination finale "),
                _createElementVNode("span", { class: "text-danger" }, "*")
              ], -1)),
              _createVNode(_component_Field, { name: "destinationFinale" }, {
                default: _withCtx(({ field, setValue }) => [
                  _createVNode(_component_Multiselect, {
                    "model-value": field.value,
                    "onUpdate:modelValue": async (val) => {
                  _ctx.form.destinationFinale = val;
                  setValue(val);
                  _ctx.onPaysDestinationChange();
                  const paysObj = _ctx.paysAvecCodes.find(p => p.value === val);
                  if (paysObj?.iso2_code) {
                    const result = await _ctx.checkBlacklist('COUNTRY', paysObj.iso2_code);
                    _ctx.blacklistAlerts.destinationFinale = result.isBlacklisted ? result.details : null;
                  } else {
                    _ctx.blacklistAlerts.destinationFinale = null;
                  }
                },
                    options: _ctx.pays,
                    searchable: true,
                    "filter-results": true,
                    "value-prop": "value",
                    label: "label",
                    "resolve-on-load": false,
                    loading: _ctx.loading,
                    placeholder: "Rechercher..."
                  }, null, 8, ["model-value", "onUpdate:modelValue", "options", "loading"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_44, [
              _cache[34] || (_cache[34] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-2" }, [
                _createTextVNode(" Port de déchargement "),
                _createElementVNode("span", { class: "text-danger" }, "*")
              ], -1)),
              _createVNode(_component_Field, { name: "portDechargement" }, {
                default: _withCtx(({ field, setValue }) => [
                  _createVNode(_component_Multiselect, {
                    "model-value": field.value,
                    "onUpdate:modelValue": async (val) => {
                  setValue(val?.value || val);
                  const port = _ctx.portsDechargement.find(p => p.value === (val?.value || val));
                  if (port?.locode) {
                    const result = await _ctx.checkBlacklist('PORT', port.locode);
                    _ctx.blacklistAlerts.portDechargement = result.isBlacklisted ? result.details : null;
                  } else {
                    _ctx.blacklistAlerts.portDechargement = null;
                  }
                },
                    options: _ctx.portsDechargementFiltres,
                    searchable: true,
                    loading: _ctx.loadingPorts,
                    placeholder: "Rechercher (nomPort ou locode)...",
                    label: "label",
                    "track-by": "value",
                    onSearchChange: _ctx.searchPortDechargement,
                    "filter-results": false,
                    "min-chars": 2,
                    "no-options-text": "Commencez à taper pour rechercher le port du pays de destination",
                    "no-results-text": "Aucun port trouvé"
                  }, null, 8, ["model-value", "onUpdate:modelValue", "options", "loading", "onSearchChange"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "portDechargement",
                    class: "text-danger d-block mt-1"
                  })
                ]),
                _: 1
              }),
              (!_ctx.form.destinationFinale)
                ? (_openBlock(), _createElementBlock("small", _hoisted_45, " Sélectionnez d'abord une destination finale "))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_46, [
              _cache[35] || (_cache[35] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-2" }, [
                _createTextVNode(" ETD (Date de Départ estimé) "),
                _createElementVNode("span", { class: "text-danger" }, "*")
              ], -1)),
              _createVNode(_component_Field, {
                name: "etd",
                type: "date",
                class: "form-control shadow-sm",
                min: _ctx.today
              }, null, 8, ["min"]),
              _createVNode(_component_ErrorMessage, {
                name: "etd",
                class: "text-danger d-block mt-1"
              })
            ]),
            _createElementVNode("div", _hoisted_47, [
              _cache[36] || (_cache[36] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-2" }, [
                _createTextVNode(" ETA (Date d'Arrivée estimée) "),
                _createElementVNode("span", { class: "text-danger" }, "*")
              ], -1)),
              _createVNode(_component_Field, {
                name: "eta",
                type: "date",
                class: "form-control shadow-sm",
                min: _ctx.form.etd || _ctx.today
              }, null, 8, ["min"]),
              _createVNode(_component_ErrorMessage, {
                name: "eta",
                class: "text-danger d-block mt-1"
              })
            ]),
            (_ctx.blacklistAlerts.transporteur || _ctx.blacklistAlerts.vessel || _ctx.blacklistAlerts.navireApresTransbordement || _ctx.blacklistAlerts.portChargement || _ctx.blacklistAlerts.portDechargement || _ctx.blacklistAlerts.destinationFinale)
              ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                  _createElementVNode("div", _hoisted_49, [
                    _cache[43] || (_cache[43] = _createElementVNode("h6", { class: "fw-bold mb-3" }, [
                      _createElementVNode("i", { class: "ph-warning-circle fs-4" }),
                      _createTextVNode(" ALERTE BLACKLIST - TRANSPORT & ITINÉRAIRE ")
                    ], -1)),
                    _createElementVNode("div", _hoisted_50, [
                      _createElementVNode("ul", _hoisted_51, [
                        (_ctx.blacklistAlerts.transporteur)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_52, [
                              _cache[37] || (_cache[37] = _createElementVNode("strong", null, "Transporteur:", -1)),
                              _createTextVNode(" Liste " + _toDisplayString(_ctx.blacklistAlerts.transporteur.list_code) + " - " + _toDisplayString(_ctx.blacklistAlerts.transporteur.reason), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.blacklistAlerts.vessel)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_53, [
                              _cache[38] || (_cache[38] = _createElementVNode("strong", null, "Navire:", -1)),
                              _createTextVNode(" Liste " + _toDisplayString(_ctx.blacklistAlerts.vessel.list_code) + " - " + _toDisplayString(_ctx.blacklistAlerts.vessel.reason), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.blacklistAlerts.navireApresTransbordement)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_54, [
                              _cache[39] || (_cache[39] = _createElementVNode("strong", null, "Navire après transbordement:", -1)),
                              _createTextVNode(" Liste " + _toDisplayString(_ctx.blacklistAlerts.navireApresTransbordement.list_code) + " - " + _toDisplayString(_ctx.blacklistAlerts.navireApresTransbordement.reason), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.blacklistAlerts.portChargement)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_55, [
                              _cache[40] || (_cache[40] = _createElementVNode("strong", null, "Port de chargement:", -1)),
                              _createTextVNode(" Liste " + _toDisplayString(_ctx.blacklistAlerts.portChargement.list_code) + " - " + _toDisplayString(_ctx.blacklistAlerts.portChargement.reason), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.blacklistAlerts.portDechargement)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_56, [
                              _cache[41] || (_cache[41] = _createElementVNode("strong", null, "Port de déchargement:", -1)),
                              _createTextVNode(" Liste " + _toDisplayString(_ctx.blacklistAlerts.portDechargement.list_code) + " - " + _toDisplayString(_ctx.blacklistAlerts.portDechargement.reason), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.blacklistAlerts.destinationFinale)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_57, [
                              _cache[42] || (_cache[42] = _createElementVNode("strong", null, "Destination finale:", -1)),
                              _createTextVNode(" Liste " + _toDisplayString(_ctx.blacklistAlerts.destinationFinale.list_code) + " - " + _toDisplayString(_ctx.blacklistAlerts.destinationFinale.reason), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_58, [
            _createVNode(_component_router_link, {
              to: "/liste-besc",
              class: "btn btn-danger px-4"
            }, {
              default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                _createTextVNode("Annuler", -1)
              ]))]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("button", {
                type: "submit",
                class: "btn btn-primary px-5 py-2 text-white",
                disabled: _ctx.loading
              }, _toDisplayString(_ctx.loading
                ? 'Enregistrement...'
                : _ctx.isEditMode
                  ? 'Mettre à jour & Continuer (Étape 2/4)'
                  : 'Valider & Continuer (Étape 2/4)'), 9, _hoisted_60)
            ])
          ])
        ]),
        _: 1
      }, 8, ["initial-values", "validation-schema", "onSubmit"])
    ]),
    (_openBlock(), _createBlock(_component_ActeurModal, {
      key: _ctx.currentTypeActeurId,
      modelValue: _ctx.showActeurModal,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showActeurModal) = $event)),
      "field-to-fill": _ctx.currentActeurField,
      "type-acteur-id": _ctx.currentTypeActeurId,
      onCreated: _ctx.onActeurCreated
    }, null, 8, ["modelValue", "field-to-fill", "type-acteur-id", "onCreated"]))
  ]))
}